import {issueTypeNodes} from './issueTypeNodes';
import {issuePriorityNodes} from './issuePriorityNodes';
import {issueStatusNodes} from './issueStatusNodes';
import {issueSummaryNodes} from './issueSummaryNodes';
import {assigneeNodes} from './userNodes';

export const issueFormNodes = view => [
  view.state.schema.nodes.grid_column.createAndFill({width: 8}, view.state.schema.nodes.form_field.createAndFill({
    required: true
  }, issueTypeNodes(view))),
  view.state.schema.nodes.grid_column.createAndFill({width: 8}, view.state.schema.nodes.form_field.createAndFill({
    required: true
  }, issuePriorityNodes(view))),
  view.state.schema.nodes.grid_column.createAndFill({width: 8}, view.state.schema.nodes.form_field.createAndFill({
    required: true
  }, issueStatusNodes(view))),
  view.state.schema.nodes.grid_column.createAndFill({width: 8}, view.state.schema.nodes.form_field.createAndFill({
  }, assigneeNodes(view))),
  view.state.schema.nodes.grid_column.createAndFill({width: 16}, view.state.schema.nodes.form_field.createAndFill({
    required: true
  }, issueSummaryNodes(view))),
  view.state.schema.nodes.grid_column.createAndFill({width: 16}, view.state.schema.nodes.form_field.createAndFill({
    required: true
  }, view.state.schema.nodes.form_text_area.create({
    id: 'description',
    name: 'description',
    rows: 10,
    richTextEditor: true
  }))),
];